<template>
  <div class="app-main-inner app-main-page" style="height:auto">
    <div class="app-main-inner-row" style="padding-top:0;padding-bottom:0">{{ $t('Partners.mergedPartners') }}：</div>
    <div class="app-main-inner-row" style="padding-top:0;padding-bottom:0">
      <div style="display: flex; width: 100%">
        <el-input v-model="inputCompanyName" no="inputCompanyName" :placeholder="$t('common.tips.fuzzySearch')" style="width:50%;padding-right: 10px" />
        <el-button no="onInput" type="primary" @click="onInput">{{ $t('common.btn.query') }}</el-button>
      </div>
    </div>
    <div class="app-main-inner-row row-grid" style="min-height:333px;">
      <cargo-ag-grid
        :grid-options="gridOptions"
        :side-bar="sideBarDefs"
        :column-defs="columnDefs"
        :row-data="rowData"
        style="width: 100%;"
        @gridReady="onGridReady"
      />
    </div>
    <div class="app-main-inner-row row-pagination" style="padding-right:0px;">
      <cargo-pagination
        v-show="total>0"
        :total="total"
        :page.sync="filter.pageNum"
        :limit.sync="filter.pageSize"
        @pagination="toQuery"
      />
    </div>
  </div>
</template>

<script>
import $store from '@/store'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import { getCompanyList } from '@/api/company'

export default {
  name: 'MergePartner',
  props: {
    serviceType: {
      type: String,
      required: true
    },
    mergeToCmpIdx: {
      type: Number,
      default: -1
    }
  },
  data() {
    return {
      needLoadingData: true, // 是否需要加载数据
      originData: [],
      inputCompanyName: '',
      filter: {
        serviceType: '',
        currentBranchId: '',
        branchIds: [],
        companyName: '',
        pageNum: 1,
        pageSize: 50
      },
      total: 0,
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true,
        context: {
          componentParent: this
        }
      },
      sideBarDefs: { toolPanels: ['columns', 'filter'], visible: false },
      columnDefs: [
        {
          headerName: this.$t('baseInfo.partner.shortName'),
          field: 'shortName'
        },
        {
          headerName: this.$t('baseInfo.partner.chineseName'),
          field: 'chineseName'
        }, {
          headerName: this.$t('baseInfo.partner.englishName'),
          field: 'englishName'
        }, {
          headerName: this.$t('SeaExport.Tel'),
          field: 'tel'
        }, {
          headerName: this.$t('SeaExport.Addr'),
          field: 'address'
        }, {
          headerName: this.$t('baseInfo.partner.isActive'),
          field: 'activeStr'
        }
      ],
      rowData: [],
      gridApi: null
    }
  },
  computed: {
    currentOfficeId() {
      return this.$store.getters.currentOffice
    }
  },
  watch: {
    currentOfficeId() {
      this.needLoadingData = true
    }
  },
  created() {
    this.filter.serviceType = this.serviceType
  },
  methods: {
    onShow() {
      this.filter.pageNum = 1
      this.filter.pageSize = 50
      this.rowData = []
      this.total = 0
      this.filter.companyName = ''
      this.inputCompanyName = ''
    },
    getSelectedRows() {
      const nodes = this.gridApi.rowModel.rowsToDisplay
      const cell = this.gridApi.getFocusedCell()
      if (cell) {
        const row = nodes[cell.rowIndex].data
        return [row]
      }
      return []
    },
    onGridReady(params) {
      this.gridApi = params.api
      this.onGridDateRendered()
    },
    toInitQuery() {
      const filter = { ...this.filter }
      const currentOffice = this.$store.getters.currentOffice
      filter.currentBranchId = currentOffice.officeId
      if (currentOffice.code !== 'HQ') {
        filter.branchIds = [currentOffice.officeId, 1]
      }
      if (this.mergeToCmpIdx > 0) {
        filter.mergeCompanyCmpIdx = this.mergeToCmpIdx
      }
      const loading = getLoading4Cxt(this)
      return getCompanyList(filter).then(res => {
        res.data.list.forEach(item => {
          item.activeStr = item.active ? this.$t('Message.Yes') : this.$t('Message.No')
        })
        this.originData = res.data.list.filter(p => p.cmpIdx !== this.mergeToCmpIdx)
        this.rowData = res.data.list
        this.filter.pageNum = res.data.pageNum
        this.filter.pageSize = res.data.pageSize
        this.total = Number(res.data.total)
      }).finally(() => {
        loading.close()
      })
    },
    onInput() {
      this.filter.companyName = this.inputCompanyName
      this.filter.pageNum = 1
      this.toQuery()
    },
    toQuery() {
      this.toInitQuery(false)
      this.onGridDateRendered()
    },
    likeCompanyName(company, keyword) {
      if (keyword) {
        const { shortName, englishName, chineseName } = company
        return shortName.indexOf(keyword) >= 0 || englishName.indexOf(keyword) >= 0 || chineseName.indexOf(keyword) >= 0
      }
      return true
    },
    onGridDateRendered() {
      const columnApi = this.gridApi.columnController.columnApi
      const columnIds = []
      this.gridApi.columnController.gridColumns.forEach(p => {
        columnIds.push(p.colId)
      })
      setTimeout(() => {
        columnApi.autoSizeColumns(columnIds)
      })
    },
    companyFilter(company) {
      const office = $store.getters.currentOffice
      if (office.officeId !== company.branchId && office.code !== 'HQ') {
        return false
      }
      if (company.global) {
        return false
      }
      return true
    }
  }
}
</script>

<style>
</style>
